import React from "react";
import { Button } from "./../../common/Button/Button";
import { useEffect, useState } from "react";
import api from "../../utils/api";
import Spinner from "../../common/Spinner/Spinner";
import { toast } from "react-toastify";
import Select from "react-select";
import { WEBAPP_URL } from "../../utils/constants";
import ReactDatePicker from "react-datepicker";
import Checkbox from "../../common/Checkbox/Checkbox";
import { getUser } from "../../utils/localStorage";
import { User } from "react-feather";
import {DOWNLOAD_API_URL}  from "../../utils/constants";
// import {WEBAPP_URL}  from "../../utils/constants";


export default function ReportsContainer(props) {


	const getshowengageduserreport = () => {
		var user = getUser();
		// if (user && user.email == "aishwarya.pathak@deasra.co.in" || user && user.email == "balaji@conveniotech.com" || user && user.email == "anshul@conveniotech.com" || user && user.email == "parag@conveniotech.com") {
			return true;
		// }
		// return false;
	}


	useEffect(() => {
		//make an api call to the server
		//for any initialisation data.
	}, []);

	const [isLoading, setLoading] = useState(false);
	const [isUnassigned, setIsUnassigned] = useState(false);

	const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

	/**Audit log entry */
	const [auditLogEntryDateFrom, setAuditLogEntryDateFrom] = useState();
	const [auditLogEntryDateTo, setAuditLogEntryDateTo] = useState();
	const onAuditLofEntryDateChange = (key, date) => {
		if (key === "fromDate") {
			setAuditLogEntryDateFrom(date);
		} else if (key === "toDate") {
			setAuditLogEntryDateTo(date);
		}
	};

	/** HH KRA report Activity Log */
	const [
		completionStatusOptionsHHKRA,
		setCompletionStatusOptionsHHKRA,
	] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedCompletionStatusHHKRA,
		setSelectedCompletionStatusHHKRA,
	] = useState({
		value: "no",
		label: "No",
	});

	const [srAssginedDateFrom, setSrAssignedDateFrom] = useState();
	const [srAssignedDateTo, setSrAssignedDateTo] = useState();
	const onSrAssignedDateChange = (key, date) => {
		if (key === "fromDate") {
			setSrAssignedDateFrom(date);
		} else if (key === "toDate") {
			setSrAssignedDateTo(date);
		}
	};

	/** Ticket-level Activity Log */

	const [logEntryDateFrom, setLogEntryDateFrom] = useState();
	const [logEntryDateTo, setLogEntryDateTo] = useState();
	const onLogEntryDateChange = (key, date) => {
		if (key === "fromDate") {
			setLogEntryDateFrom(date);
		} else if (key === "toDate") {
			setLogEntryDateTo(date);
		}
	};
	/**Service Request to Fullfilment */
	const [srRequestedDateFrom, setSrRequestedDateFrom] = useState();
	const [srRequestedDateTo, setSrRequestedDateTo] = useState();
	const onSrRequestedDateChange = (key, date) => {
		if (key === "fromDate") {
			setSrRequestedDateFrom(date);
		} else if (key === "toDate") {
			setSrRequestedDateTo(date);
		}
	};






	/**Engaged User Report */

	const [engagedDateFrom, setengagedDateFrom] = useState();
	const [engagedDateTo, setengagedDateTo] = useState();
	const onEngagedUSerDateChange = (key, date) => {
		if (key === "fromDate") {
			setengagedDateFrom(date);
		} else if (key === "toDate") {
			setengagedDateTo(date);
		}
	};

	/**









	/**Twoplusthreeplus */

	const [twoplusthreeDateFrom, settwoplusthreeDateFrom] = useState();
	const [twoplusthreeDateTo, settwoplusthreeDateTo] = useState();
	const ontwoplusthreeDateChange = (key, date) => {
		if (key === "fromDate") {
			settwoplusthreeDateFrom(date);
		} else if (key === "toDate") {
			settwoplusthreeDateTo(date);
		}
	};

	/*

	
	 * All Services Report
	 */
	const [
		allServicesReportProgressionDateFrom,
		setAllServicesReportProgressionDateFrom,
	] = useState();
	const [
		allServicesReportProgressionDateTo,
		setAllServicesReportProgressionDateTo,
	] = useState();
	const onAllServicesReportProgressionDateChange = (key, date) => {
		if (key === "fromDate") {
			setAllServicesReportProgressionDateFrom(date);
		} else if (key === "toDate") {
			setAllServicesReportProgressionDateTo(date);
		}
	};
	/**
	 * Services Action Report
	 *
	 */
	const [
		completionStatusOptionsFollowupActions,
		setCompletionStatusOptionsFollowupActions,
	] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedCompletionStatusFollowupActions,
		setSelectedCompletionStatusFollowupActions,
	] = useState({
		value: "no",
		label: "No",
	});
	const [
		dateRangeOptionsFollowupAction,
		setDateRangeOptionsFollowupActions,
	] = useState([
		{
			value: "dtFollowupOn",
			label: "Followup On",
		},
		{
			value: "dtCreated",
			label: "Logged on",
		},
		{
			value: "dtUpdated",
			label: "Updated on",
		},
	]);

	const ticketLevelActivityFilters = [{
		value: "c_email",
		label: "Customer Email"
	},
	{
		value: "contact_no",
		label: "Contact Number"
	},
	{
		value: "nResourceInstanceId",
		label: "Service Instance ID"
	},
	{
		value: "actor_email",
		label: "Actor Email - IHH/FAC/EHH/ESP/SP"
	}]

	const [
		selectedTicketLevelActivityFilter,
		setSelectedTicketLevelActivityFilter,
	] = useState({});

	const [
		selectedDateRangeFollowupAction,
		setSelectedDateRangeOptions,
	] = useState({
		value: "dtFollowupOn",
		label: "Followup On",
	});
	const [
		servicesActionsReportFollowupDateFrom,
		setServiesActionsReportFollowupDateFrom,
	] = useState();
	const [
		servicesActionsReportFollowupDateTo,
		setServicesActionsReportFollowupDateTo,
	] = useState();
	const onServicesActionsReportFollowupDateChange = (key, date) => {
		if (key === "fromDate") {
			setServiesActionsReportFollowupDateFrom(date);
		} else if (key === "toDate") {
			setServicesActionsReportFollowupDateTo(date);
		}
	};

	const fetchAllServicesReport = () => {
		setLoading(true);
		try {
			api.getAllServicesReport({
				fromDate: allServicesReportProgressionDateFrom,
				toDate: adjustedToDate(allServicesReportProgressionDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					console.log(error.status);
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchFullfillmentReport = () => {
		setLoading(true);
		try {
			api.getFullfillmentReport({
				fromDate: srRequestedDateFrom,
				toDate: adjustedToDate(srRequestedDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};


	const fetchTicketLevelReport = () => {
		setLoading(true);
		try {
			api.getTicketLevelLog({
				fromDate: logEntryDateFrom,
				toDate: adjustedToDate(logEntryDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchUserRoleAccessReport = () => {
		setLoading(true);
		try {
			api.getUserRoleAccessReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchRoleAccessReport = () => {
		setLoading(true);
		try {
			api.getRoleAccessReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchAuditLogReport = () => {
		setLoading(true);
		try {
			api.getAuditLogReport({
				fromDate: auditLogEntryDateFrom,
				toDate: adjustedToDate(auditLogEntryDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchServiceCatalogueReport = () => {
		setLoading(true);
		try {
			api.getServiceCatalogueReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchServiceActionReport = () => {
		setLoading(true);
		try {
			api.getServiceActionReport({
				date_range: selectedDateRangeFollowupAction.value,
				fromDate: servicesActionsReportFollowupDateFrom,
				toDate: adjustedToDate(servicesActionsReportFollowupDateTo),
				completion_status:
					selectedCompletionStatusFollowupActions.value,
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchKRAReport = () => {
		setLoading(true);
		try {
			api.getKRAReport({
				fromDate: srAssginedDateFrom,
				toDate: adjustedToDate(srAssignedDateTo),
				completion_status: selectedCompletionStatusHHKRA.value,
				unassigned: isUnassigned
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			console.log("second")
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchImpactMetricReport = () => {
		setLoading(true);
		try {
			api.getImpactMetricReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchImpactMetricTransactionReport = () => {
		setLoading(true);
		try {
			api.getImpactMetricTransactionReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchEngagementReport = () => {
		setLoading(true);
		try {
			api.getEngagementReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchUserFeedbackReport = () => {
		setLoading(true);
		try {
			api.getCustomerFeedbackReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchCustomerFRTReport = () => {
		setLoading(true);
		try {
			api.getCustomerFRTReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};



	const fetchtwoplusthreeplusReport = () => {
		setLoading(true);
		try {
			api.get2_plus_3_plusReport({
				fromDate: twoplusthreeDateFrom,
				toDate: adjustedToDate(twoplusthreeDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};


	const fetchEngagedUserReport = () => {
		setLoading(true);
		try {
			api.getEngagedUserReport({
				fromDate: engagedDateFrom,
				toDate: adjustedToDate(engagedDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchFirstTimeUserReport = () => {
		setLoading(true);
		try {
				api.getFirstTimeUserReport({
					fromDate: engagedDateFrom,
					toDate: adjustedToDate(engagedDateTo),
				})
					.then(({ data }) => {
						toast(data["details"], {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
						window.open(data["generated_file"], "_self");
						setLoading(false);
					})
					.catch((error) => {
						setLoading(false);
						toast(error["response"]["data"]["message"], {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};



	return (
		<>
			<div className={`row  ${isLoading && "set-opacity"}`}>
				{isLoading && <Spinner className="center-screen" />}
				{
					<div className="col-12 conv-pb20">

						<div className="row reports-top-menu">
							<div className="col-12">
								<div className="row  conv-mt30 ">
									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchUserRoleAccessReport}>
											User Role Access Report
										</button>
									</div>
									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchRoleAccessReport}>
											Role Access Report
										</button>
									</div>

									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchServiceCatalogueReport}>
											Service Catalogue Report
										</button>
									</div>

									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchImpactMetricTransactionReport}>
											Impact Metric Transactions Report
										</button>
									</div>
								</div>

								<div className="row conv-mt30">
									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchImpactMetricReport}>
											Impact Metric Report
										</button>
									</div>

									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchEngagementReport}>
											Engagement Report
										</button>
									</div>

									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchUserFeedbackReport}>
											Customer Feedback Report
										</button>
									</div>

									<div className="col-3 spled-container">
										<button
											type="button"
											className="reports-button conv-width-100p"
											onClick={fetchCustomerFRTReport}>
											FRT Report
										</button>
									</div>
								</div>

								<div className="row  conv-mt30">
									<div className="col-3 spled-container">
										<a href={WEBAPP_URL} target="_blank" className="reports-link ">
											Go to webapp reports
										</a>
									</div>
								</div>

							</div>
						</div>
						<div className="row conv-pl230 conv-pr230 conv-mt30">
							<div className="col-12">
								<span className="reports-title">HH KRA Report </span>
								<span className="sample-file-name-label conv-ml20">(Sample File Name: HH KRA Report13Oct18-09.xlsx)</span>
							</div>
						</div>
						<div className="row conv-pl230 conv-mt30 conv-pr230">
							<div className="col-3">
								<span className="sample-file-name-label">SR Assigned Date:</span>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={srAssginedDateFrom}
										onChange={(date) =>
											onSrAssignedDateChange("fromDate", date)
										}
										placeholderText="From"
									/>
								</div>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={srAssignedDateTo}
										onChange={(date) => onSrAssignedDateChange("toDate", date)}
										placeholderText="To"
									/>
								</div>
							</div>

							<div className="col-3"></div>
						</div>
						<div className="row conv-pl230 conv-mt30 conv-pr230 reports-border-bottom">
							<div className="col-3">
								<span className="sample-file-name-label">Completion Status: </span>
							</div>
							<div className="col-3 spled-container">
								<Select
									styles={{
										// Fixes the overlapping problem of the component
										menu: provided => ({ ...provided, zIndex: 3 })
									}}
									placeholder="Completion Status"
									options={completionStatusOptionsHHKRA}
									onChange={(value) =>
										setSelectedCompletionStatusHHKRA(value)
									}
									value={selectedCompletionStatusHHKRA}
									className='react-select-container'
									classNamePrefix="react-select"
									theme={theme => ({
										...theme,
										colors: {
											...theme.colors,
											primary: '#76287C',
											primary25: '#F4DFF4',
										},
									})}
								></Select>
							</div>
							<div className="col-3 spled-container">
								<div className="lpm-checkbox-label conv-pr5 conv-align-self-center">
									<Checkbox
										id={`Show-Only-Unassigned`}
										checked={isUnassigned}
										onChange={() => setIsUnassigned(!isUnassigned)}
										label={"Unassigned Only"}
									></Checkbox>
								</div>
							</div>
							<div className="col-3">
								<button
									type="button"
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
									onClick={fetchKRAReport}>
									Download
								</button>
							</div>
						</div>


						<div className="row conv-pl230 conv-pr230 conv-mt30">
							<div className="col-12">
								<span className="reports-title">SPM All Followup Actions </span>
								<span className="sample-file-name-label conv-ml20">(Sample File Name: SPM-FU-Actions-13Oct18-10.xlsx)</span>
							</div>
						</div>

						<div className="row conv-pl230 conv-mt30 conv-pr230">
							<div className="col-3 spled-container">
								<Select
									styles={{
										// Fixes the overlapping problem of the component
										menu: provided => ({ ...provided, zIndex: 3 })
									}}
									customStylingClass="status-dropdown-custom-style-report-container"
									placeholder="Select completion status"
									options={
										dateRangeOptionsFollowupAction
									}
									onChange={(value) =>
										setSelectedDateRangeOptions(
											value
										)
									}
									value={
										selectedDateRangeFollowupAction
									}
									className='react-select-container'
									classNamePrefix="react-select"
									theme={theme => ({
										...theme,
										colors: {
											...theme.colors,
											primary: '#76287C',
											primary25: '#F4DFF4',
										},
									})}
								></Select>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={servicesActionsReportFollowupDateFrom}
										onChange={(date) =>
											onServicesActionsReportFollowupDateChange("fromDate", date)
										}
										placeholderText="From"
									/>
								</div>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={servicesActionsReportFollowupDateTo}
										onChange={(date) => onServicesActionsReportFollowupDateChange("toDate", date)}
										placeholderText="To"
									/>
								</div>
							</div>

							<div className="col-3">
								<button
									type="button"
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
									onClick={fetchServiceActionReport}>
									Download
								</button>
							</div>

							<div className="col-3"></div>
						</div>

						<div className="row conv-pl230 conv-mt30 conv-pr230 reports-border-bottom">
							<div className="col-3">
								<span className="sample-file-name-label">Completion Status: </span>
							</div>
							<div className="col-3 spled-container">
								<Select
									styles={{
										// Fixes the overlapping problem of the component
										menu: provided => ({ ...provided, zIndex: 3 })
									}}
									placeholder="Completion Status"
									options={completionStatusOptionsFollowupActions}
									onChange={(value) =>
										setSelectedCompletionStatusFollowupActions(value)
									}
									value={selectedCompletionStatusFollowupActions}
									className='react-select-container'
									classNamePrefix="react-select"
									theme={theme => ({
										...theme,
										colors: {
											...theme.colors,
											primary: '#76287C',
											primary25: '#F4DFF4',
										},
									})}
								></Select>
							</div>

						</div>


						<div className="row conv-pl230 conv-pr230 conv-mt30">
							<div className="col-12">
								<span className="reports-title">All Services in Progression </span>
								<span className="sample-file-name-label conv-ml20">(Sample File Name: ServicesInSPM.xlsx)</span>
							</div>
						</div>

						<div className="row conv-pl230 conv-mt30 conv-pr230 reports-border-bottom">
							{/* <div className="col-3">
                                <span className="sample-file-name-label">Progression Date:</span>
                            </div> */}

							{/* <div className="col-3 spled-container">                                
                                <div className="width-100">                                    
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={allServicesReportProgressionDateFrom}
                                        onChange={(date) =>
                                            onAllServicesReportProgressionDateChange("fromDate", date)
                                        }
                                        placeholderText="From"
                                    />
                                </div>
                            </div> */}

							{/* <div className="col-3 spled-container">                                
                                <div className="width-100">
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={allServicesReportProgressionDateTo}
                                        onChange={(date) => onAllServicesReportProgressionDateChange("toDate", date)}
                                        placeholderText="To"
                                    />
                                </div>
                            </div> */}

							<div className="col-3">
								{/* <button 
                                    type="button" 
                                    className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
                                    onClick={fetchAllServicesReport}>
                                    Download
                                </button> */}

								<a className="con-cursor-pointer"
									href={`${DOWNLOAD_API_URL}/static_live/Reports/ServicesInSPM.xlsx`} download="ServicesInSPM.xlsx">

									<button
										className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35">
										Download
									</button>
								</a>

							</div>

							<div className="col-3"></div>
						</div>




						<div className="row conv-pl230 conv-pr230 conv-mt30">
							<div className="col-12">
								<span className="reports-title">Service Requests to Fullfilment </span>
								<span className="sample-file-name-label conv-ml20">(Sample File Name: ReqToFulfillment.xlsx)</span>
							</div>
						</div>

						<div className="row conv-pl230 conv-mt30 conv-pr230">
							{/* <div className="col-3">
								<span className="sample-file-name-label">Service Request Date:</span>
							</div> */}

							{/* <div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={srRequestedDateFrom}
										onChange={(date) =>
											onSrRequestedDateChange("fromDate", date)
										}
										placeholderText="From"
									/>
								</div>
							</div>
 */}
							{/* <div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={srRequestedDateTo}
										onChange={(date) => onSrRequestedDateChange("toDate", date)}
										placeholderText="To"
									/>
								</div>
							</div> */}

							<div className="col-3">
								{/* <button
									type="button"
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
									onClick={fetchFullfillmentReport}>
									Download
								</button> */}
								<a className="con-cursor-pointer"
									href={`${DOWNLOAD_API_URL}/static_live/Reports/ReqToFulfillment.xlsx`} download="ReqToFulfillment.xlsx">

									<button
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35">
										Download
									</button>
								</a>

							</div>

							<div className="col-3"></div>
						</div>


						<div className="row conv-pl230 conv-pr230 conv-mt30 reports-border-bottom">
							<div className="col-12">
								{/* <span className="reports-title">All Services in Progression </span> */}
								<span className="sample-file-name-label">
									To Download Service Requests to Fullfilment Report older than 1st Jan, 2024, {" "}
									<a className="con-cursor-pointer"
										href={`${DOWNLOAD_API_URL}/static_live/Reports/ReqToFulfillment2013to2023.xlsx`} download="ReqToFulfillmentOld.xlsx">

										<span className="text-hover" style={{ cursor: 'pointer' }}>

											Click here</span>
									</a>
								</span>
							</div>
						</div>




						<div className="row conv-pl230 conv-pr230 conv-mt30">
							<div className="col-12">
								<span className="reports-title">Ticket-level Activity Log </span>
								<span className="sample-file-name-label conv-ml20">(Sample File Name: TicketLevelLog-13Oct18-12.xlsx)</span>
							</div>
						</div>

						<div className="row conv-pl230 conv-mt30 conv-pr230 reports-border-bottom">
							<div className="col-3">
								<span className="sample-file-name-label">Log Entry Date:</span>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={logEntryDateFrom}
										onChange={(date) =>
											onLogEntryDateChange("fromDate", date)
										}
										placeholderText="From"
									/>
								</div>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={logEntryDateTo}
										onChange={(date) => onLogEntryDateChange("toDate", date)}
										placeholderText="To"
									/>
								</div>
							</div>

							<div className="col-3">
								<button
									type="button"
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
									onClick={fetchTicketLevelReport}>
									Download
								</button>
							</div>

							{/* <div className="row  conv-mt30">
									<div className="col-3 spled-container">
									<span> <b>Hint</b> - Form and To date interval cannot exceed 3 months </span>
									</div>
								</div>	 */}

							<div className="col-12 conv-mt30">
								<span> <b>Hint</b> - Form and To date interval cannot exceed 3 months </span>
							</div>

							<div className="col-3"></div>
						</div>


						<div className="row conv-pl230 conv-pr230 conv-mt30">
							<div className="col-12">
								<span className="reports-title">Audit Log Report </span>
								<span className="sample-file-name-label conv-ml20">(Sample File Name: Audit Log Report.xlsx)</span>
							</div>
						</div>

						<div className="row conv-pl230 conv-mt30 conv-pr230 reports-border-bottom">
							<div className="col-3">
								<span className="sample-file-name-label">Entry Date:</span>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={auditLogEntryDateFrom}
										onChange={(date) =>
											onAuditLofEntryDateChange("fromDate", date)
										}
										placeholderText="From"
									/>
								</div>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={auditLogEntryDateTo}
										onChange={(date) => onAuditLofEntryDateChange("toDate", date)}
										placeholderText="To"
									/>
								</div>
							</div>

							<div className="col-3">
								<button
									type="button"
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
									onClick={fetchAuditLogReport}>
									Download
								</button>
							</div>

							<div className="col-3"></div>
						</div>



						<div className="row conv-pl230 conv-pr230 conv-mt30">
							<div className="col-12">
								<span className="reports-title">2 Plus 3 Plus Report </span>
								<span className="sample-file-name-label conv-ml20">(Sample File Name: User2Plus3PlusReport-26Apr18-33.xlsx)</span>
							</div>
						</div>

						<div className="row conv-pl230 conv-mt30 conv-pr230 reports-border-bottom">
							<div className="col-3">
								<span className="sample-file-name-label">Entry Date:</span>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={twoplusthreeDateFrom}
										onChange={(date) =>
											ontwoplusthreeDateChange("fromDate", date)
										}
										placeholderText="From"
									/>
								</div>
							</div>

							<div className="col-3 spled-container">
								<div className="width-100">
									<ReactDatePicker
										dateFormat="dd/MM/yyyy"
										selected={twoplusthreeDateTo}
										onChange={(date) => ontwoplusthreeDateChange("toDate", date)}
										placeholderText="To"
									/>
								</div>
							</div>

							<div className="col-3">
								<button
									type="button"
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
									onClick={fetchtwoplusthreeplusReport}>
									Download
								</button>
							</div>

							<div className="col-3"></div>
						</div>








						{
							//props.email === "abhi2021@mailinator.com"?
							getshowengageduserreport() ?

								(
									<>
										<div className="row conv-pl230 conv-pr230 conv-mt30">
											<div className="col-6">
												<span className="reports-title">Facilitation Engaged User Data </span>
												<span className="sample-file-name-label conv-ml20">(Sample File Name : EngageUserReport.xlsx )</span>
											</div>

											<div className="col-6">
												<span className="reports-title">First Time User Data </span>
												<span className="sample-file-name-label conv-ml20">(Sample File Name : FirstTimeUserReport.xlsx )</span>
											</div>
										</div>

										<div className="row conv-pl230 conv-mt30 conv-pr230">
											<div className="col-3">
												{/* <button
													type="button"
													className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
													onClick={fetchEngagedUserReport}>
													Download
												</button> */}
												<a className="con-cursor-pointer"
									href={`${DOWNLOAD_API_URL}/static_live/Reports/EngageUserReport.xlsx`} download="EngageUserReport.xlsx">

									<button
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35">
										Download
									</button>
								</a>
											</div>

											<div className="col-3"></div>

											<div className="col-3">
												{/* <button
													type="button"
													className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
													onClick={fetchFirstTimeUserReport}>
													Download
												</button> */}
												<a className="con-cursor-pointer"
									href={`${DOWNLOAD_API_URL}/static_live/Reports/FirstTimeUserReport.xlsx`} download="FirstTimeUserReport.xlsx">

									<button
									className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35">
										Download
									</button>
								</a>
											</div>

											<div className="col-3"></div>
										</div>

										<div className="row conv-pl230 conv-pr230 conv-mt30 reports-border-bottom">
											<div className="col-6">
												<span className="sample-file-name-label">
													To Download Facilitation Engaged User Report older than 1st Jan, 2024, {" "}
													<a className="con-cursor-pointer"
														href={`${DOWNLOAD_API_URL}/static_live/Reports/EngageUserReport2013to2023.xlsx`} download="EngageUserReportOld.xlsx">

														<span className="text-hover" style={{ cursor: 'pointer' }}>

															Click here</span>
													</a>
												</span>
											</div>

											<div className="col-6">
												<span className="sample-file-name-label">
													To Download First Time User Report older than 1st Jan, 2024, {" "}
													<a className="con-cursor-pointer"
														href={`${DOWNLOAD_API_URL}/static_live/Reports/FirstTimeUserReport2013to2023.xlsx`} download="FirstTimeUserReportOld.xlsx">

														<span className="text-hover" style={{ cursor: 'pointer' }}>

															Click here</span>
													</a>
												</span>
											</div>
										</div>

									</>
								) :
								("")
						}






						{/* <div className="row conv-pl230 conv-pr230 conv-mt30">
                            <div className="col-12">
                                <span className="reports-title">Facilitation Engaged User Data </span>
                                <span className="sample-file-name-label conv-ml20">(Sample File Name : EngageUserReport-18Jul22-53.xlsx )</span>
                            </div>
                        </div>

						<div className="row conv-pl230 conv-mt30 conv-pr230 reports-border-bottom">                           
                            <div className="col-3">
                                <span className="sample-file-name-label">Entry Date:</span>
                            </div>

                            <div className="col-3 spled-container">                                
                                <div className="width-100">                                    
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={engagedDateFrom}
                                        onChange={(date) =>
                                            onEngagedUSerDateChange("fromDate", date)
                                        }
                                        placeholderText="From"
                                    />
                                </div>
                            </div>

                            <div className="col-3 spled-container">                                
                                <div className="width-100">
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={engagedDateTo}
                                        onChange={(date) => onEngagedUSerDateChange("toDate", date)}
                                        placeholderText="To"
                                    />
                                </div>
                            </div>

							<div className="col-3">
                                <button 
                                    type="button" 
                                    className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
                                    onClick={fetchEngagedUserReport}>
                                    Download
                                </button>
                            </div>

                            <div className="col-3"></div>
                        </div> */}





					</div>
				}
			</div>
		</>
	)
}
